import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface IProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute = ({
  children,
}: IProtectedRouteProps): JSX.Element | null => {
  const authManager = useAuth();

  if (!authManager.getToken()) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute;
